import React from 'react'
import classNames from "classnames";

// plugin that creates slider
import nouislider from "nouislider";
import wNumb from "wnumb";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

class SwipeTool extends React.Component {

  componentDidMount() {
    this.slider = this.refs.slider;

    nouislider.create(this.slider, {
      start: this.props.sliderPosition,
      connect: [false, true],
      step: 1,
      range: { min: 0, max: 100 },
      tooltips: false,
      format: wNumb({
        decimals: 0
      }),
      cssPrefix: "noUiBig-"
    });
    this.slider.noUiSlider.on('update', function() {
      if (this.props.onSetPosition) {
        this.props.onSetPosition(this.slider.noUiSlider.get());
      }

      // let children = this.slider.getElementsByClassName('noUiBig-handle')
      // console.log(children);
      // let value = this.slider.noUiSlider.get()


      // if (children.length > 0) {
      //   console.log('here', children[0]);
      //   children[0].innerHTML = value;
      // }

    }.bind(this))

    let children = this.slider.getElementsByClassName('noUiBig-handle')
    if (children.length > 0) {
      children[0].innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path fill="white" d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/></svg>';
      children[0].classList.add("noSelect")
    }

  }

  render() {
    const { classes } = this.props;
    return (
      <div id="swipe-container" className={classNames(classes.swipeToolContainer, classes.dimTool)}>
        <div id="swipe-slider" className = {classNames(classes.dimTool)} >
          <div ref="slider" className={classNames(classes.swipeSlider, "noUi-big", "slider-success")} />
        </div>
      </div>
    );
  }
}

export default withStyles(mapStyle)(SwipeTool);